exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#main {\n  display: block;\n  /*position: relative;*/\n}\n\n.parent {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n}\n.child {\n  margin-right: 100px;\n}\n\nh3 {\n  padding: 15px;\n}\ninput {\n  margin-top: 20px;\n  height: 30px;\n  width: 260px;\n  border: solid purple 2px;\n}\n\n.userLogin {\n  margin-top: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/page_components/login/login.component.css
// module id = 376
// module chunks = 1